module.exports = __webpack_public_path__ + "assets/img/sp2.94fe60c8.jpg";